import toast from "react-hot-toast";
import useCreate from "../../useCreate";
import { useState } from "react";

const useDeleteUsers = () => {
  const { setDataToServer: deleteReq } = useCreate({
    url: "auth/delete_admin",
    refreshUrl: "auth/admin_list",
    onSuccess: () => {
      // Handle success, e.g., show a success message or redirect
      toast.success("User deleted successfully");
      toggleConfirmation();
    },
    onError: (error) => {
      // Handle error, e.g., show an error message
      toast.error(`Error deleting user: ${error.message}`);
    },
  });

  const [idToDelete, setIdToDelete] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const toggleConfirmation = (userId) => {
    setIdToDelete(userId);
    setShowConfirmation((prev) => !prev);
  };

  const deleteUser = () => {
    if (idToDelete) {
      deleteReq.mutate({ user_id: idToDelete });
    }
  };

  return {
    toggleConfirmation,
    showConfirmation,
    deleteUser,
  };
};

export default useDeleteUsers;
